namespace TabAurous.Inventory {
    export namespace RejectionForRepairService {
        export const baseUrl = 'Inventory/RejectionForRepair';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<Stock.StockItemRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Inventory/RejectionForRepair/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>RejectionForRepairService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
